<template>
  <div id="coba-inline-edit">
    <b-table :items="filteredItems" :fields="fields" hover striped outlined>
      <template #head(title)>
        <div class="d-flex align-items-center">
          <span>title</span>
          <b-form-input
            id="input_title"
            v-if="filter_title"
            type="text"
            class="form-control form-custom mx-1 w-75 ml-auto"
            v-model="filter_value.title"
            @keypress.enter="filter_title = false"
          ></b-form-input>
          <label
            for="input_title"
            :class="filter_title ? '' : 'ml-auto'"
            class="mt-2"
          >
            <i
              class="bi bi-funnel-fill"
              style="font-size: 16px"
              :style="filter_value.title != '' ? 'color:#28a745' : ''"
              @click="filter_title = !filter_title"
            ></i>
          </label>
        </div>
      </template>
      <template #head(content)>
        <div class="d-flex align-items-center">
          <span>content</span>
          <b-form-input
            id="input_content"
            v-if="filter_content"
            type="text"
            class="form-control form-custom mx-1 w-50 ml-auto"
            v-model="filter_value.content"
            @keypress.enter="filter_content = false"
          ></b-form-input>
          <label
            for="input_content"
            :class="filter_content ? '' : 'ml-auto'"
            class="mt-2"
          >
            <i
              class="bi bi-funnel-fill fa-2x"
              style="font-size: 16px"
              :style="filter_value.content != '' ? 'color:#28a745' : ''"
              @click="filter_content = !filter_content"
            ></i>
          </label>
        </div>
      </template>
      <template #head(source)>
        <div class="d-flex align-items-center">
          <span>Sumber</span>
          <b-form-select
            v-if="filter_source"
            @change="filter_source = false"
            v-model="filter_value.source"
            :options="option_source"
            size="sm"
            class="w-50 ml-auto mr-2"
          >
            <template #first>
              <b-form-select-option :value="''" selected
                >Semua</b-form-select-option
              >
            </template>
          </b-form-select>
          <i
            class="bi bi-funnel-fill fa-2x"
            :style="filter_value.source != '' ? 'color:#28a745' : ''"
            :class="filter_source ? '' : 'ml-auto'"
            @click="filter_source = !filter_source"
          ></i>
        </div>
      </template>
      <template #cell(title)="data">
        <b-form-input
          v-if="filteredItems[data.index].isEdit && selectedCell === 'title'"
          type="text"
          v-model="filteredItems[data.index].title"
          @keyup.enter="submitForm(data, 'title')"
        ></b-form-input>
        <span v-else @dblclick="editCellHandler(data, 'title')">
          {{ data.value }}
        </span>
      </template>
      <template #cell(content)="data">
        <b-form-textarea
          v-if="filteredItems[data.index].isEdit && selectedCell === 'content'"
          id="textarea"
          v-model="filteredItems[data.index].content"
          @keyup.enter="submitForm(data, 'content')"
          rows="3"
          max-rows="10"
        ></b-form-textarea>
        <span v-else @dblclick="editCellHandler(data, 'content')">
          {{ data.value }}
        </span>
      </template>
      <template #cell(date)="data">
        <b-form-datepicker
          v-if="filteredItems[data.index].isEdit && selectedCell === 'date'"
          v-model="filteredItems[data.index].date"
          @input="submitForm(data, 'date')"
        ></b-form-datepicker>
        <span v-else @dblclick="editCellHandler(data, 'date')">
          {{ data.value }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "Inline",
  data() {
    return {
      filter_title: false,
      filter_content: false,
      filter_source: false,
      option_title: [],
      option_content: [],
      option_source: ["Media Cetak", "Online News", "Media TV"],
      filter_value: {
        title: "",
        content: "",
        source: "",
      },
      fields: [
        { key: "title", label: "title", thClass: "bg-white w-25" },
        {
          key: "content",
          label: "content",
          thClass: "bg-white",
          tdClass: "text-justify",
        },
        {
          key: "source",
          label: "source",
          thClass: "bg-white text-center",
          thStyle: "width:20%",
        },
      ],
      items: [
        {
          content:
            "BINJAI, TRIBUN - Banjir yang menerjang 11 kecamatan di Kabupaten Serdangbedagal membuat 10 ribu hektare sawah mulik petani rusak terendam air, Tg Kepala Dinas pertanian Kabupaten Serdangbedagal Dedy Iskandar mengatakan, kerusakan ribuan hektare sawah terjadi sejak banjir pada Jumat (16/12) kemarin. Dikatakannya, dua kecamatan yang paling parah adalah Tanjung Beringin dan Bandar Khalifah. Didua lokasi ini ribuan hektare tanaman petani terendam air dan mati. “Dari data kita ada 10.849 hektare sawah petani yang rusak karena banjir yang terjadi di 11 Kecamatan yang mengalami banjir,” latar Dedy kepada Tribun Rabu (21/12).",
          title: "Lahan Pertanian di Kecamatan Sergai Rusak",
          date: "2022-12-21",
          source: "Media Cetak",
          isEdit: false,
        },
        {
          content:
            "TEMANGGUNG (KR) kementerian pertanian meminta petani menerapkan model soil block dalam budidaya bawang dan cabai, karena lebih murah, mudah cepat dan lebih baik sehingga hasilnya lebih menguntungkan petani. Dirjen Hortikultura kementerian pertanian , Prihasto Setyanto mengatakan soil block merupakan alat untuk membantu persemaian tanpa plastik, sehingga ramah lingkungan. 'Soil block merupakan inovasi untuk pertanian ,'' jelas Prihasto Setyanto saat menanam bawang merah di Desa Tuksari Kecamatan Kledung, Kabupaten Temanggung, Minggu (18/12).",
          title: "Terapkan Model 'Soil Block'",
          date: "1984-05-21",
          source: "Online News",
          isEdit: false,
        },
        {
          content:
            "SURABAYA - Kebutuhan telepon dan pesan singkat kini mulai bergeser. Masyarakat beralih menggunakan data untuk segala aspek kehidupannya. Untuk itu, penyedia layanan telekomunikasi memproyeksi trafik data akan meroket saat Natal dan tahun baru (nataru). Head of Region East Java & Bali Nusra Indosat Ooredoo Hutchison (IOH) Soejanto Prasetya mengatakan, populasi pengguna mencapai 100 juta jiwa. Dia memproyeksi lonjakan trafik data telekomunikasi sebesar 50 persen. Angka ini lebih tinggi ketimbang 2021 lalu sekitar 30 persen.",
          title: "Nataru, Trafik Data Telekomunikasi Diproyeksi Naik 50 Persen",
          date: "1984-05-20",
          source: "Media TV",
          isEdit: false,
        },
        {
          content:
            "BOGOR Balai Besar Pelatihan Peternakan (BBPP) Kupang menyelenggarakan Training Of Trainer (TOT) dengan tema Gerakan Tani Pro Organik (Genta Organik) bagi Widyaiswara, Dosen, Guru, dan Penyuluh Pertanian yang dilaksanakan selama 3 hari berturut-turut, yang berlokasi di Pusat Pelatihan Manajemen dan Kepemimpinan Pertanian (Ciawi).",
          title:
            "SUKSESKAN PROGRAM GENTA ORGANIK, POLBANGTAN BOGOR IKUTI TRAINING OF TRAINER BERTANI ORGANIK",
          date: "1984-05-20",
          source: "Media Cetak",
          isEdit: false,
        },
      ],
      selectedCell: null,
    };
  },
  methods: {
    submitForm(data, value) {
      this.items = this.items.map((item) => ({ ...item, isEdit: false }));
      this.items[data.index].isEdit = false;
      console.log(value);
    },
    editCellHandler(data, value) {
      this.items = this.items.map((item) => ({ ...item, isEdit: false }));
      this.filteredItems[data.index].isEdit = true;
      this.selectedCell = value;
    },
  },
  computed: {
    filteredItems() {
      let filtered = this.items.filter(
        (el) =>
          el.title
            .toLowerCase()
            .includes(this.filter_value.title.toLowerCase()) &&
          el.content
            .toLowerCase()
            .includes(this.filter_value.content.toLowerCase()) &&
          el.source
            .toLowerCase()
            .includes(this.filter_value.source.toLowerCase())
      );
      return filtered;
    },
    fieldKeys() {
      return Object.keys(this.items[0]);
    },
    options() {
      const options = {};
      this.fieldKeys.forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },
  },
};
</script>

<style scoped>
thead,
tbody,
tfoot,
tr,
td,
th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
}
pre {
  text-align: left;
  color: #000;
}
.form-control .form-custom {
  border-radius: 5px !important;
}
</style>